import { createEffect, createSignal, onMount } from "solid-js";
import { v4 as uuidv4 } from "uuid";
import {
  getBrowserAndDevice,
  specialEventActions,
  type EventType,
} from "./_utils";
import { getUser } from "./authorization";

const RRRSESSIONKEY = "rrr-session-id";

const [sessionId, setSessionId] = createSignal<string | null>(null);
const [events, setEvents] = createSignal<string[]>([]);
const [isAuthorized, setIsAuthorized] = createSignal<boolean>(false);

//const [location, setLocation] = createSignal<GeolocationPosition>();

const getSessionStorageSessionId = () =>
  window.sessionStorage.getItem(RRRSESSIONKEY);

const setSessionStorageSessionId = (sessionId: string) => {
  window.sessionStorage.setItem(RRRSESSIONKEY, sessionId);
};

export const logEvent = ({
  eventType,
  data,
}: {
  eventType: EventType;
  data?: object;
}) => {
  const { browser, device } = getBrowserAndDevice();
  const metadata = {
    eventType: eventType,
    url: window.location.href,
    qsps: window.location?.search,
    referrer: document.referrer,
    title: document.title,
    timestamp: new Date().getTime(),
    browser: browser,
    device: device,
    version: "1.1.42",
    //location: location()?.coords,
  };

  specialEventActions({ eventType, data, metadata });

  setEvents([
    ...events(),
    JSON.stringify({
      sessionId: sessionId(),
      metadata: metadata,
      eventData: data || {},
    }),
  ]);
};

const initialize = () => {
  if (!sessionId() || sessionId() === "") {
    const sessionId = uuidv4();
    setSessionStorageSessionId(sessionId);
    setSessionId(sessionId);
  }
};

onMount(() => {
  const sessionId = getSessionStorageSessionId();
  if (sessionId) setSessionId(sessionId);
  else initialize();

  //getLocation((pos: GeolocationPosition) => setLocation(pos));
});

export const flushEvents = () => {
  navigator?.sendBeacon(
    import.meta.env.PUBLIC_SERVER_URL + "/api/public/session-data",
    JSON.stringify(events())
  );
  setEvents([]);
};

createEffect(() => {
  if (events().length >= 5) {
    flushEvents();
  }
});

createEffect(() => {
  const user = getUser();

  if (user?.email && !isAuthorized()) {
    setIsAuthorized(true);
    logEvent({ eventType: "authorized", data: { email: user.email } });
  } else if (!user && isAuthorized()) {
    setIsAuthorized(false);
    logEvent({ eventType: "logout" });
  }
});
